import { MUITab } from "@abb/arcadia-ui-react"
import { useContext, useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../../services/api"
import {
  DiMaDetailsHeader,
  DiMaDetailsHeaderProps,
} from "../../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../../components/DiMaProgress"
import { UserContext } from "../../../../context/UserContext"
import { ApplicationPermissionGet } from "../../../../models/ApplicationPermission"
import { useHashTab } from "../../../../../hooks/useHashTab"
import { ApplicationPermissionDetails } from "./details_tab/ApplicationPermissionDetails"
import { ApplicationPermissionFirmwareConstraints } from "./fw_constraints_tab/ApplicationPermissionFirmwareConstraints"

export function ApplicationPermissionContainer() {
  const { applicationId, permissionId } = useParams()
  const { user, isLoadingUser } = useContext(UserContext)
  const returnURL = `/applications/${applicationId}#permissions`
  const navigate = useNavigate()

  const { activeTab, handleTabChange: handleChange } = useHashTab("details")

  const [permission, setPermission] = useState<ApplicationPermissionGet>()

  useEffect(() => {
    if (applicationId && permissionId) {
      digitalManagerApi
        .get<ApplicationPermissionGet>(
          `/applications/${applicationId}/permissions/${permissionId}`
        )
        .then((res) => {
          setPermission(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [applicationId, permissionId, navigate, returnURL])

  if (!applicationId || !permissionId) {
    return <Navigate to="/applications" />
  }

  if (!permission || isLoadingUser || !user) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: permission.name,
    label: "Permission ID",
    subtitle: permission.id,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(12, 1fr)", gap: 1 }}>
        <div style={{ gridColumn: "span 10" }}>
          <DiMaDetailsHeader {...detailsHeaderProps} />
        </div>
      </div>
      <MUITab
        tabItems={[
          { id: "details", label: "Details" },
          { id: "fw-constraints", label: "FW Constraints" },
        ]}
        value={activeTab}
        handleChange={handleChange}
      />
      {activeTab === "details" && (
        <ApplicationPermissionDetails
          permission={permission}
          applicationId={applicationId}
          user={user}
          setPermission={setPermission}
        />
      )}
      {activeTab === "fw-constraints" && <ApplicationPermissionFirmwareConstraints />}
    </div>
  )
}
